import { RadioGroupInput } from '@framework/form/inputs/RadioGroupInput.tsx';
import { FormItem } from '@framework/form/item/FormItem.tsx';
import { CHECKBOX_EVIDENCE_CARD_LAYOUT } from '@framework/form/item/formItemLayouts.ts';
import { SwitchEvidenceCard } from '@framework/ui/components/configuration-card/SwitchEvidenceCard.tsx';
import { WidgetConfigurationSubCard } from '@framework/ui/components/configuration-card/widget/WidgetConfigurationSubCard.tsx';
import { TbIcon } from '@framework/ui/components/icon/TbIcon.tsx';
import { StyledTag } from '@framework/ui/components/tag/StyledTag.tsx';
import { IconEye } from '@tabler/icons-react';
import { useWatch } from 'react-hook-form';
import { WidgetConfigurationSlotRender } from '../../widgets/repository/common/config-slots/WidgetConfigurationSlotRender.tsx';
import { WidgetConfigurationSlots } from '../../widgets/repository/common/config-slots/WidgetConfigurationSlots.tsx';
import { PdfVisibilityDirectiveKind } from './IPdfVisibilityDirective.ts';

function getVisibilityExtra(visibility: PdfVisibilityDirectiveKind) {
  switch (visibility) {
    case PdfVisibilityDirectiveKind.PDF:
      return <StyledTag color="purple">Solo PDF</StyledTag>;
    case PdfVisibilityDirectiveKind.COMPILATION:
      return <StyledTag color="blue">Solo Compilazione</StyledTag>;
    case PdfVisibilityDirectiveKind.ALL:
      return (
        <>
          <StyledTag color="blue">Compilazione</StyledTag>
          <StyledTag color="purple">PDF</StyledTag>
        </>
      );
    default:
      return undefined;
  }
}

export interface IPdfVisibilityDirectiveConfigComponentProps {
  name: string;
}

export function PdfVisibilityDirectiveConfigComponent(
  props: IPdfVisibilityDirectiveConfigComponentProps,
) {
  const { name } = props;

  const visibility = useWatch({ name: `${name}.visibility` });
  return (
    <WidgetConfigurationSlotRender
      slot={WidgetConfigurationSlots.SpecialBehaviors}
    >
      <WidgetConfigurationSubCard
        icon={<TbIcon icon={IconEye} />}
        title="Visibilità nella sezione"
        extra={getVisibilityExtra(visibility) ?? undefined}
      >
        <SwitchEvidenceCard removeTopPadding>
          <FormItem
            name={`${name}.visibility`}
            label="Visibilità nella sezione"
            layout={CHECKBOX_EVIDENCE_CARD_LAYOUT}
            help="Indica se il campo deve apparire solo nel PDF, solo in compilazione o in entrambi."
          >
            <RadioGroupInput
              name={`${name}.visibility`}
              options={[
                { label: 'Entrambi', value: PdfVisibilityDirectiveKind.ALL },
                {
                  label: 'Visibile solo nel PDF',
                  value: PdfVisibilityDirectiveKind.PDF,
                },
                {
                  label: 'Visibile solo in compilazione',
                  value: PdfVisibilityDirectiveKind.COMPILATION,
                },
              ]}
            />
          </FormItem>
        </SwitchEvidenceCard>
      </WidgetConfigurationSubCard>
    </WidgetConfigurationSlotRender>
  );
}
